import React from 'react';
const noMore = ['No more hours rebuilding grooming lessons', 'No more searching for random teaching resources', 'No more explaining difficult techniques without visual support', 'No more disconnected lesson ideas', 'No more wondering which skill should come next', 'No more recreating the same explanations over and over', 'No more starting every class from an empty page'];
export function FinalCTA() {
  return <section className="py-24 px-4 bg-blue-950 relative overflow-hidden" data-id="element-105" data-mp="m3dpm2iqzjgo">
      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-106" data-mp="h6n8dbv7ihto">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-8 leading-tight text-white uppercase" data-id="element-107" data-mp="vurtemhqf5fm">
          Next Week You Can Keep Planning Every Dog Grooming Class From Scratch...
          <br data-id="element-108" data-mp="14vg0ex8pk5j0" />
          <span className="text-orange-500" data-id="element-109" data-mp="14uwru74y6thn">
            Or You Can Open a Complete Teaching System and Already Know Where to Start.
          </span>
        </h2>
        <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/5 p-8 rounded-2xl border border-white/15" data-id="element-110" data-mp="zua6wx784e8f">
          {noMore.map(item => <div key={item} className="flex items-start gap-3" data-id="element-111" data-mp="2h4ss4ns5g3wy">
              <span className="text-orange-500 mt-0.5" aria-hidden="true" data-id="element-112" data-mp="2m2udjfd1sfbl">
                ▸
              </span>
              <span className="text-white/85" data-id="element-113" data-mp="2r2gotj9bflhr">{item}</span>
            </div>)}
        </div>
        <p className="text-xl md:text-2xl font-bold text-white mb-2" data-id="element-114" data-mp="2v428pok9p01g">
          Dog Grooming Instructor Ready Does Not Replace Your Experience.
        </p>
        <p className="text-xl text-white/80 mb-6" data-id="element-115" data-mp="300ivoffqd8cy">
          It gives you a system for using that experience with greater:
        </p>
        <p className="text-lg md:text-2xl font-extrabold tracking-widest text-orange-500" data-id="element-116" data-mp="39s5ccrau7zn3">
          STRUCTURE · CLARITY · CONSISTENCY · EFFICIENCY
        </p>
      </div>
    </section>;
}